// Core imports
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Component imports
import { Col, Row } from 'antd';
import HelviaCard from '../components/UI/HelviaCard';
import RegistrationForm from '../components/Forms/RegistrationForm';

// Misc imports
import { NAV_LOGIN } from '../constants/navigation';
import LogoFull from '../assets/logo-full.svg';

const RegistrationScreen = () => {
  const navigate = useNavigate();

  // Redirect to the login screen
  // TODO: This should be removed once the registration is re-enabled
  useEffect(() => {
    navigate(NAV_LOGIN);
  }, []);

  return (
    <HelviaCard
      leftSideContent={<RegistrationForm />}
      rightSideContent={
        <Row justify="center" align="middle" className="h-100">
          <Col>
            <img src={LogoFull} alt="logo" width={240} />
          </Col>
        </Row>
      }
    />
  );
};

export default RegistrationScreen;
